import { Component, Input, Optional } from '@angular/core';

import { UiPlatformMessageType } from './models/message.model';

@Component({
  selector: 'ui-platform-message',
  templateUrl: './message.component.html',
  styleUrl: './message.component.less',
  standalone: false
})
export class MessageComponent {
  @Input() messageCode = '';
  @Input() type!: UiPlatformMessageType;

  @Optional() @Input() hasCloseBtn = false;

  private _closed = false;

  get closed(): boolean {
    return this._closed;
  }

  close() {
    this._closed = true;
  }
}
